/**
 * Status of batch job execution
 */
export enum BatchStatus {
    /**
     * Pending execution
     */
    Pending = 0,

    /**
     * Currently processing
     */
    Processing = 1,

    /**
     * Completed successfully
     */
    Completed = 2,

    /**
     * Failed with error
     */
    Failed = 3
}
